const doc = [({"en":({"js":({"components":({"admin":({"layout":({"menu":({"menu_content":({"translate":"Translate", "crm":"CRM", "liquid_drops":"Liquid drops"})})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;